export default function CTA() {
  const whatsappNumber = "5555992338351";
  const whatsappMessage = encodeURIComponent("Olá! Acabei de acessar o seu site e me interessei. Gostaria de agendar uma consulta.");

  return (
    <section className="relative bg-white py-24 px-5 sm:px-8 lg:px-16 overflow-hidden">
      {/* Decorative circles */}
      <div className="absolute top-10 left-10 w-32 h-32 rounded-full border border-[#C9A84C]/10"></div>
      <div className="absolute bottom-10 right-10 w-40 h-40 rounded-full border border-[#C9A84C]/10"></div>
      <div className="absolute top-1/2 left-1/4 w-24 h-24 rounded-full bg-[#C9A84C]/5"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10">

        {/* Label */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-10 h-px bg-[#C9A84C]"></div>
          <span className="text-[#C9A84C] text-xs tracking-[0.25em] uppercase font-semibold" style={{ fontFamily: 'DM Sans, sans-serif' }}>
            Agende sua Avaliação
          </span>
          <div className="w-10 h-px bg-[#C9A84C]"></div>
        </div>

        {/* Title */}
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a1a1a] mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
          Agende sua <span className="italic text-[#C9A84C]">avaliação</span>
        </h2>

        {/* Description */}
        <p className="text-[#666] text-base sm:text-lg leading-relaxed mb-10 max-w-2xl mx-auto" style={{ fontFamily: 'DM Sans, sans-serif' }}>
          Descubra um plano personalizado para remodelação glútea, emagrecimento, performance e contorno corporal.
        </p>

        {/* Button */}
        <a
          href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
          target="_blank"
          onclick="return gtag_report_conversion('https://wa.me/5555992338351');"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#C9A84C] text-white text-sm font-semibold uppercase tracking-widest rounded-full hover:bg-[#b8943e] transition-all duration-300 active:scale-95 whitespace-nowrap cursor-pointer shadow-lg shadow-[#C9A84C]/30 mb-12"
          style={{ fontFamily: 'DM Sans, sans-serif' }}
        >
          <i className="ri-whatsapp-line text-lg"></i>
          Falar no WhatsApp
        </a>

        {/* Trust badges */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#C9A84C]/10">
              <i className="ri-time-line text-[#C9A84C] text-lg"></i>
            </div>
            <span className="text-[#888] text-sm" style={{ fontFamily: 'DM Sans, sans-serif' }}>Resposta em até 2h</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#C9A84C]/10">
              <i className="ri-shield-check-line text-[#C9A84C] text-lg"></i>
            </div>
            <span className="text-[#888] text-sm" style={{ fontFamily: 'DM Sans, sans-serif' }}>Atendimento seguro</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#C9A84C]/10">
              <i className="ri-map-pin-line text-[#C9A84C] text-lg"></i>
            </div>
            <span className="text-[#888] text-sm" style={{ fontFamily: 'DM Sans, sans-serif' }}>RS e SC</span>
          </div>
        </div>
      </div>
    </section>
  );
}